import React from "react";
import Icondigital from "../../icons/icon-digital.svg";
import IconDataAnalytics from "../../icons/icon-data-analytics.svg";
import Imagedigital from "../../images/icon-digital.svg";
import ImageDataAnalytics from "../../images/icon-data-analytics.svg";
import IconSaas from "../../icons/icon-saas-Products.svg";
import IconDigitalPlatforms from "../../icons/icon-digital-platforms.svg";
import IconEnterpriseApps from "../../icons/icon-enterprise-apps.svg";
import IconEcommerce from "../../icons/icon-eCommerce.svg";
import IconInteractive from "../../icons/icon-interactive-data.svg";
import IconTailor from "../../icons/icon-tailor-made.svg";
import IconLaunch from "../../icons/icon-launch.svg";
import IconDeliverMvp from "../../icons/icon-deliver-mvp.svg";
import IconRevenue from "../../icons/icon-revenue.svg";
import IconStrategy from "../../icons/icon-strategy.svg";
import IconDesign from "../../icons/icon-design.svg";
import IconEngineering from "../../icons/icon-engineering.svg";
import IconTesting from "../../icons/icon-testing.svg";
import IconDelivery from "../../icons/icon-delivery.svg";
import IconMaintenance from "../../icons/icon-maintenance.svg";
import IconAngular from "../../icons/icon-angular-js.svg";
import IconReact from "../../icons/icon-react.svg";
import IconNode from "../../icons/icon-node.svg";
import IconUnitTest from "../../icons/icon-unit-testing.svg";
import IconCicd from "../../icons/icon-cicd.svg";
import IconGit from "../../icons/icon-git.svg";
import IconAws from "../../icons/icon-aws.svg";
import IconMaterialJS from "../../icons/icon-material-js.svg";
import IconCytoscape from "../../icons/icon-cytoscape.svg";
import IconGraphQl from "../../icons/icon-graph-ql.svg";
import IconHtml from "../../icons/icon-html.svg";
import IconMicroServices from "../../icons/icon-microservices.svg";
import IconRubyRails from "../../icons/icon-ruby-rails.svg";
import ImageUserTodd from "../../images/todd-profile.png";
import ImageUserWang from "../../images/wang-profile.jpg";
import ImageUserBlank from "../../images/user-profile.png";
import IconZurn from "../../images/icon-zurn.png";
import IconTresata from "../../images/icon-tresata.svg";
import IconAtdw from "../../images/icon-atdw.svg";
import ProductBannerImage from "../../images/page-banner-salesmate.png";
import ProductBannerVideo from "../../images/web-page-banner.mp4";
import { Link } from "gatsby";
import IconOutstandingExperiences from "../../icons/icon-deliver-outstanding-experiences.svg";
import IconStandCrowd from "../../icons/icon-stand-crowd.svg";
import IconIncreaseEfficiencies from "../../icons/icon-increase-efficiencies.svg";

  import ImageHT from "../../images/services-cs-ht.png";
  import ImageSalesmateHalf from "../../images/service-cs-salesmate-half.jpg";
  import ImageCBHalf from "../../images/service-cs-cb-half.jpg";

export const webBlockQuoteObj = {
  classes: "md-blockquote",
  quote: "Salesmate is a vast and complicated product. Thanks to Rapidops’ digital team for bringing it to life with the right strategy, simplicity, and scale we never imagined possible.",
  author: "Brian",
  occupation: "DIRECTOR, SALESMATE.IO ",
};
export const columnLayoutObj = {
  classes: "",
  header: "Check out other services",
  subHeader: (<></>),
  services: [
    {
      image: ImageDataAnalytics,
      alt: "data analytics services",
      title: "Data Analytics",
      header: "Data Analytics",
      content: "Grow your business with actionable intelligence and data-driven products.",
      link: "/services/data-analytics/"
    }, {
      image: Imagedigital,
      alt: "web application development company",
      title: "Product Design",
      header: "Product Design",
      content: "Craft state-of-the-art digital experiences for your next digital product.",
      link: "/services/digital-product/"
    }
  ]
};
export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "our web development expertise",
  subHeader: "What we can build for you on the web",
  gridItems: [
    {
      icon: <IconSaas />,
      header: "SaaS Products",
      content: "Ship beautiful, intuitive, and multi-tenant  Software-as-a-Service products in weeks using cutting-edge web technologies and engineering."
    },
    {
      icon: <IconDigitalPlatforms />,
      header: "Digital Platforms",
      content: "Build a robust and extendable platform that is the foundation (and the most valuable asset) for all digital products, channels, and customer journeys."
    },
    {
      icon: <IconEnterpriseApps />,
      header: "Scalable Enterprise Apps",
      content: "Develop new or transform existing enterprise applications that deliver enterprise efficiencies with top-notch architecture, tech stack, and security."
    },
    {
      icon: <IconEcommerce />,
      header: "eCommerce & Payments",
      content: "Generate online sales, create recurring revenue streams, and on-demand payment solutions unique and tailor-made to your business needs."
    },
    {
      icon: <IconInteractive />,
      header: "Interactive Data Analytics Apps",
      content: "Launch interactive data-driven products that can integrate, analyze, and visualize the massive amounts of data to deliver intelligence."
    },
    {
      icon: <IconTailor />,
      header: "Tailor-made CMS",
      content: "Share your story with next-gen content management systems that allow you to curate, design and publish high-quality content across multiple channels."
    },
  ]
};
export const introColumnObj = {
  classes: "service-inner-intro",
  header: "Our Web Development Services",
  subHeader: "Craft with the best-in-class tech and engineering that allows you to launch fast, stay agile & lead the market.",
  intro: (<><p>We deeply care about shipping products that are simple and beautiful inside out. Hence, we only pick technologies, talent, and web development practices that allow us to build high-quality software in an agile fashion.</p>
    <p>Leveraging technologies that allow to ship modular, reliable, and maintainable web apps quickly. We describe the technology choices as not losing sight of the forest while standing at the tree, i.e., delivering on your current needs in weeks, but being flexible to scale and grow on-demand to meet your dynamic business needs all digital channels.</p></>),
};
export const mainBannerObj = {
  classes: " ",
  title: "Web Development Services",
  header: (<>Web Development <br />Services</>),
  content: "Unlock disruptive possibilities for your business with cutting-edge technology and industry-leading web development expertise.",
  mediaType: "video",
  mediaSource: ProductBannerVideo,
  mediaClass: "align-v-center"
};
export const pageIntroObj = {
  classes: "section-gap",
  title: "Monetize your Web app",
  header: "Grow your business with our end-to-end web development services",
  content: (<><p>Launching successful web-based products is a multi-dimensional and complex journey. Understanding market trends and customers’ needs, identifying product opportunities, selecting the technology stack, finding the right partner, developing a scalable, secure, and reliable product that delivers on your business goals is not easy.</p>
    <p>With our full-stack expertise and battle-tested agile approach, we help companies excel at each stage of the web product development lifecycle to start shipping success in as few as 3 weeks. That is why companies like Kroger, Harris Teeter, Dassault Systems, and Tresata turns to us to build the new-class of web-enabled products, services, and digital platforms.</p></>)
};

export const threeColSliderObj = {
  classes: " ",
  header: "Deliver on your mission-critical initiatives",
  subHeader: "Our custom web development services",
  items: [
    {
      icon: <IconLaunch />,
      header: "Launch new products & services",
      content: "Deliver an innovative  and intuitive web-based product that your customers will love to use."
    }, {
      icon: <IconDeliverMvp />,
      header: "Deliver an MVP in weeks",
      content: "Use cutting-edge tech to transform your ideas into a real product in a matter of weeks  (not months)."
    }, {
      icon: <IconRevenue />,
      header: "Create a new revenue stream",
      content: "Create new digital revenue channels by offering fast, repeatable and high-quality web-enabled services."
    }, {
      icon: <IconOutstandingExperiences />,
      header: "Deliver outstanding experiences",
      content: "Create simple and intuitive digital experiences that will help you get customers and win their loyalty."
    }, {
      icon: <IconStandCrowd />,
      header: "Stand out from the crowd",
      content: "Craft unique digital presence that will attract, delight and engage customers on web."
    }, {
      icon: <IconIncreaseEfficiencies />,
      header: "Modernize enterprise apps",
      content: "Unlock new efficiencies by reshaping existing apps with fast, secure and scalable technologies."
    }
  ]
};

export const processFlowObj = {
  classes: "",
  title: "agile software development",
  header: "Proven and battle-tested process",
  subHeader: "With 11 years and 200+ products, we’ve battle-tested our approach to products, people, and processes. From vision to strategy to a roadmap to delivery and beyond, we go end-to-end; no other vendor needed to fill the gaps. We stay lean, move fast, and deliver tangible product in weeks (not the $50,000 PPT or vaporware).",
  items: [
    {
      class: "process-item border-bottom",
      icon: <IconStrategy />,
      name: "Strategy"
    },
    {
      class: "process-item border-right",
      icon: <IconDesign />,
      name: "Design"
    },
    {
      class: "process-item border-right border-bottom",
      icon: <IconEngineering />,
      name: "Engineering"
    },
    {
      class: "process-item",
      icon: <IconTesting />,
      name: "Testing"
    },
    {
      class: "process-item border-right border-top-right-radius",
      icon: <IconDelivery />,
      name: "Delivery"
    },
    {
      class: "process-item",
      icon: <IconMaintenance />,
      name: "Maintenance"
    }
  ]
};

export const techColumnObj = {
  classes: "wd-grid-layout",
  items: [
    {
      icon: <IconAngular />,
      alt: "icon angular",
      header: "AngularJS",
      content: "Create the best-in-class user interfaces that are premium and is most loved JS front end framework by the tech community."
    }, {
      icon: <IconNode />,
      alt: "icon node",
      header: "Node.js",
      content: "Get the best in class lightning fast back end ecosystem for next-generation ideas turning to products within no time."
    }, {
      icon: <IconReact />,
      alt: "icon react",
      header: "React",
      content: "Make visually stunning digital products that are super flexible in terms of agility and serves native-like experience."
    },
  ]
};

export const techSliderObj = {
  classes: "five-col",
  items: [
    {
      link: "/",
      image: <IconAws />,
      alt: "icon aws",
      name: "AWS"
    },
    {
      link: "/",
      image: <IconMaterialJS />,
      alt: "icon MaterialJS",
      name: "MaterialJS"
    },
    {
      link: "/",
      image: <IconCytoscape />,
      alt: "icon Cytoscape",
      name: "Cytoscape"
    },
    {
      link: "/",
      image: <IconGraphQl />,
      alt: "icon graph",
      name: "GraphQL"
    },
    {
      link: "/",
      image: <IconHtml />,
      alt: "icon html",
      name: "HTML5/CSS3"
    },
    {
      link: "/",
      image: <IconMicroServices />,
      alt: "icon micro services",
      name: "MicroServices"
    },
    {
      link: "/",
      image: <IconCicd />,
      alt: "icon cicd",
      name: "CI/CD"
    },
    {
      link: "/",
      image: <IconGit />,
      alt: "icon git",
      name: "Git"
    },
    {
      link: "/",
      image: <IconRubyRails />,
      alt: "icon ruby",
      name: "Ruby on Rails"
    },
    {
      link: "/",
      image: <IconUnitTest />,
      alt: "icon unit testing",
      name: "Unit Testing"
    },
  ]
};

export const testimonialSliderObj = {
  classes: "",
  title: <>We've shipped award-winning mobile apps for our clients</>,
  header: "See how we lived before existing customers.",
  link: "/",
  items: [
    {
      content: "The quality offered by Rapidops has been outstanding, bar none. They deliver consistently good products on time and within budget. ",
      userImage: ImageUserTodd,
      userImageAlt: "Todd",
      userImageTitle: "Todd",
      authorName: "Todd",
      authorOccupation: "Director of Marketing, Zurn",
      logo: IconZurn,
      width: "80",
      logoAlt: "Zurn",
      logoTitle: "Zurn"
    }, {
      content: "I genuinely appreciate the work they delivered; they made it far better than we'd imagined. They’re committed to providing digital products that have longer-term viability.",
      userImage: ImageUserWang,
      userImageAlt: "Michael Wang",
      userImageTitle: "Michael Wang",
      authorName: "Michael Wang",
      authorOccupation: "IT Manager, Australian Tourism Data Warehouse",
      logo: IconAtdw,
      width: "61",
      logoAlt: "Australian Tourism Data Warehouse",
      logoTitle: "Australian Tourism Data Warehouse"
    }
  ]
};

export const pageFeatureBannerObj = {
  classes: "",
  header: "Salesmate",
  subHeader: "The sales CRM made for you",
  content: <>Organize your sales process, win more deals, and create <br />happy customers with automated sales CRM.</>,
  link: <Link to="/work/salesmate-sales-crm/" className="button button-white-blue right-arrow">View Case Study</Link>,
  imageIsInsideRow: true,
  image: ProductBannerImage,
  alt: "custom web application development",
  title: "Web Application Development"
};


export const succesStoriesObj = {
  classesForFullColumn: "cs-ht",
  imageForFullColumn: ImageHT,
  imageAltForFullColumn: "Salesmate CRM Dashboard",
  imageTitleForFullColumn: "crm dashboard",
  categoryForFullColumn: "RETAIL",
  headerForFullColumn: "A fresh take on online grocery shopping",
  subHeaderForFullColumn: (<>How did we help Harris Teeter transform their business with digital retail and omnichannel experiences.</>),
  linkForFullColumn:'/work/harris-teeter-online-grocery-shopping/',
  
  classesForhalfColumn1: "cs-cb-hlaf",
  imageForHalfColumn1: ImageCBHalf,
  imageAltForHalfColumn1: "digital transformation in manufacturing",
  imageTitleForHalfColumn1: "digital transformation in manufacturing",
  categoryForHalfColumn1: "MANUFACTURING",
  headerForHalfColumn1: "Enabling digital evolution in manufacturing",
  linkForForHalfColumn1: '/work/digital-transformation-manufacturing/',

  classesForhalfColumn2: "cs-salesmate-hlaf",
  imageForHalfColumn2: ImageSalesmateHalf,
  imageAltForHalfColumn2: "Salesmate CRM Dashboard",
  imageTitleForHalfColumn2: "crm dashboard",
  categoryForHalfColumn2: "CRM",
  headerForHalfColumn2: "Salesmate",
  linkForForHalfColumn2: '/work/salesmate-sales-crm/',
};


export const ctaObj = {
  title: <>Ready to monetize digital transformation?</>,
  subtitle: <>Find your opportunities with our FREE <strong>rapidDiscovery</strong> bootcamp.</>,
};